var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-content pl-2 pr-2" }, [
    _c("div", { staticClass: "form-group" }, [
      _c("div", [
        _c("label", { staticClass: "col-md-2 control-label" }, [
          _vm._v("Room Types"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-10" },
          [
            _c("div", { staticClass: "checkbox" }, [
              _c("input", {
                attrs: {
                  type: "checkbox",
                  name: "hotelRooms",
                  value: "true",
                  disabled: _vm.payload.selectClosed,
                },
                domProps: {
                  checked:
                    _vm.payload.selectedHotelRooms.length ===
                    _vm.payload.hotelRooms.length,
                },
                on: {
                  change: function ($event) {
                    return _vm.toggleAllHotelRooms()
                  },
                },
              }),
              _vm._v(" All Room Types\n                "),
            ]),
            _vm._v(" "),
            _vm._l(_vm.payload.hotelRooms, function (hotelRoom) {
              return _c("div", { staticClass: "checkbox" }, [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    disabled: _vm.payload.selectClosed,
                  },
                  domProps: {
                    checked: _vm.payload.selectedHotelRooms.includes(
                      hotelRoom.hotelRoomKey
                    ),
                  },
                  on: {
                    change: function ($event) {
                      return _vm.toggleHotelRoom(hotelRoom.hotelRoomKey)
                    },
                  },
                }),
                _vm._v(" " + _vm._s(hotelRoom.name) + "\n                "),
              ])
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", [
        _c("label", { staticClass: "col-md-2 control-label" }, [
          _vm._v("Availability"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-10" }, [
          _c("div", { staticClass: "checkbox" }, [
            _c("input", {
              attrs: {
                type: "checkbox",
                name: "availability",
                disabled: _vm.payload.selectClosed,
              },
              on: {
                change: function ($event) {
                  return _vm.toggleShowAvailability()
                },
              },
            }),
            _vm._v(" Room Availability\n                "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkbox" }, [
            _c("input", {
              attrs: { type: "checkbox", name: "closed", value: "true" },
              on: {
                change: function ($event) {
                  return _vm.toggleClosed()
                },
              },
            }),
            _vm._v(" Whole Property Closed\n                "),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", [
        _c("label", { staticClass: "col-md-2 control-label" }, [
          _vm._v("Rates"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-10" },
          [
            _vm._l(_vm.payload.rateTypes, function (rate, index) {
              return _c("div", { key: index, staticClass: "checkbox" }, [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    disabled: _vm.payload.selectClosed,
                  },
                  on: {
                    change: function ($event) {
                      return _vm.toggleRateType(rate.rateTypeKey)
                    },
                  },
                }),
                _vm._v(" " + _vm._s(rate.name) + "\n                "),
              ])
            }),
            _vm._v(" "),
            _vm.payload.additionalRates.length
              ? _c(
                  "div",
                  [
                    _c("hr", { staticClass: "mb-1" }),
                    _vm._v(" "),
                    _vm._l(_vm.payload.additionalRates, function (rate) {
                      return _c("div", { staticClass: "checkbox" }, [
                        _c("input", {
                          attrs: {
                            type: "checkbox",
                            disabled: _vm.payload.selectClosed,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.toggleAdditionalRate(rate.field)
                            },
                          },
                        }),
                        _vm._v(
                          " " + _vm._s(rate.text) + "\n                    "
                        ),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("div", [
        _c("label", { staticClass: "col-md-2 control-label" }, [
          _vm._v("Restrictions"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-10" },
          _vm._l(_vm.payload.restrictions, function (restriction) {
            return _c("div", { staticClass: "checkbox" }, [
              _c("input", {
                attrs: { type: "checkbox", disabled: _vm.payload.selectClosed },
                on: {
                  change: function ($event) {
                    return _vm.toggleRestriction(restriction.value)
                  },
                },
              }),
              _vm._v(" " + _vm._s(restriction.text) + "\n                "),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }